export const normalizeCouponCode = (code) => String(code || '').trim().toUpperCase()

export const formatCouponBenefitTitle = (coupon = {}) => {
  const parts = []

  if (coupon.bonus_credits) {
    parts.push(`+${coupon.bonus_credits} créditos de bônus`)
  }
  if (coupon.bonus_documents) {
    parts.push(`+${coupon.bonus_documents} documentos de bônus`)
  }

  if (!parts.length) {
    return 'Cupom válido'
  }

  if (parts.length === 1) {
    return parts[0]
  }

  return `${parts[0]} e ${parts[1]}`
}

export const formatCouponBenefitShort = (coupon = {}) => {
  const parts = []

  if (coupon.bonus_credits) {
    parts.push(`+${coupon.bonus_credits} créditos`)
  }
  if (coupon.bonus_documents) {
    parts.push(`+${coupon.bonus_documents} documentos`)
  }

  return parts.join(' · ')
}

export const getCouponFrequencyLabel = (coupon = {}, context = 'credits') => {
  if (!coupon.is_recurring) {
    return 'Bônus único (entra uma vez)'
  }

  const cycles = coupon.recurring_cycles ?? coupon.cycles
  if (context === 'plan') {
    if (cycles) {
      return `Você ganha esse bônus por ${cycles} meses`
    }
    return 'Bônus mensal enquanto o cupom estiver ativo'
  }

  if (cycles) {
    return `Bônus por ${cycles} ciclos`
  }

  return 'Bônus a cada ciclo'
}

export const getCouponFrequencyBadge = (coupon = {}, context = 'credits') => {
  if (!coupon.is_recurring) {
    return 'bônus único'
  }

  const cycles = coupon.recurring_cycles ?? coupon.cycles
  if (cycles) {
    return context === 'plan' ? `por ${cycles} meses` : `por ${cycles} ciclos`
  }

  return context === 'plan' ? 'mensal' : 'a cada ciclo'
}

export const getCouponBenefitDescription = (context = 'credits', coupon = {}) => {
  const hasDocuments = Number(coupon.bonus_documents) > 0
  const hasCredits = Number(coupon.bonus_credits) > 0

  if (context === 'plan' || (context === 'redeem' && hasDocuments && !hasCredits)) {
    return 'Documentos extras para assinar.'
  }

  if (context === 'redeem' && hasDocuments && hasCredits) {
    return 'Créditos e documentos extras para usar no Assinafy.'
  }

  return 'Créditos são usados no envio por WhatsApp (e em breve em outros recursos do Assinafy).'
}

export const getRedeemReceiveSummary = (coupon = {}) => {
  const parts = []
  const bonusCredits = Number(coupon.bonus_credits) || 0
  const bonusDocuments = Number(coupon.bonus_documents) || 0

  if (bonusCredits > 0) {
    parts.push(`${bonusCredits} créditos`)
  }
  if (bonusDocuments > 0) {
    parts.push(`${bonusDocuments} documentos`)
  }

  return parts.join(' + ') || 'Benefício do cupom'
}

export const getCreditsReceiveSummary = (purchasedCredits, coupon = {}) => {
  const bonusCredits = Number(coupon.bonus_credits) || 0
  const bonusDocuments = Number(coupon.bonus_documents) || 0
  const totalCredits = Number(purchasedCredits) + bonusCredits
  const parts = [`${totalCredits} créditos`]

  if (bonusDocuments > 0) {
    parts.push(`${bonusDocuments} documentos`)
  }

  return parts.join(' + ')
}

export const getPlanReceiveSummary = (planMaxDocuments, coupon = {}) => {
  const bonusDocuments = Number(coupon.bonus_documents) || 0
  const bonusCredits = Number(coupon.bonus_credits) || 0
  const parts = [`${planMaxDocuments} docs/mês`]

  if (bonusDocuments > 0) {
    parts.push(`${bonusDocuments} documentos`)
  }
  if (bonusCredits > 0) {
    parts.push(`${bonusCredits} créditos`)
  }

  return parts.join(' + ')
}
